export default __webpack_public_path__ + "static/media/mugAllT.2dd3ea07.jpg";